import React from "react";
import Pagination from "@mui/material/Pagination";
import { RECORDS_LIMIT } from "../../../developmentContent/constants";

const PaginationComponent = ({ totalRecords, currentPage = 1, setCurrentPage }) => {
  const parsedRecords = Number(totalRecords);
  if (!parsedRecords || isNaN(parsedRecords) || parsedRecords <= 0) return null;

  const limit = Number(RECORDS_LIMIT) || 10;
  const totalPages = Math.ceil(parsedRecords / limit);

  const handleChange = (event, value) => {
    if (typeof setCurrentPage === "function") {
      setCurrentPage(value);
    }
  };

  if (!totalPages || isNaN(totalPages) || totalPages <= 1) return null;

  return (
    <>
      <style>{`
       .MuiPagination-ul{
        justify-content: center;
        gap:20px;
        align-items: center;
        height: 100%;
       }
        .MuiPagination-ul li button {
            border: 2px solid #C7C9C8;
            width: 35px;
            height: 35px;
            border-radius: 6px;
            margin-top: 40%;
          
        }
        .MuiPagination-ul li .Mui-selected{
            color: #191818 !important;
           
            background: #FDEEC9 !important;
        }
        .MuiPagination-ul li button {
            text-align: center;
            font-weight: 600; 
            color: #363636;
 font-family: "Inter", serif !important;
            color:rgba(54, 54, 54, 0.75) !important;
         
             font-size:18px !important;
  
        }
        .MuiPaginationItem-previousNext{
          display: none;
        }
    `}</style>
      <div>
        <Pagination
          count={totalPages}
          page={Number(currentPage) || 1}
          onChange={handleChange}
          shape="rounded"
        />
      </div>
    </>
  );
};

export default PaginationComponent;
